import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_RC } from '@shared/navigation/constants/routes.constants';
import { AuthStore } from '@shared/modules/auth/store/auth.store';

export const authGuard: CanActivateFn = () => {
  if (inject(AuthStore).accessToken()) return true;

  return inject(Router).createUrlTree([AUTH_RC.root]);
};
